import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=ec3f4198"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=ec3f4198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports